
import Vue from 'vue'

// 初始化vue-router
// 0. 导入Vue和VueRouter，要调用 Vue.use(VueRouter)
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 1. 定义 (路由) 组件。
// 可以从其他文件 import 进来
import Login from '@/pages/Login'
import Home from '@/pages/home/Index'

import Service from '@/pages/service/Index'
import ServiceView from '@/pages/service/View'

const BookAudio = () => import(/* webpackChunkName: "book" */ '@/pages/book/Audio');

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', redirect: '/home' },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                title: '登录',
                dialog: true
            }
        },
        {
            path: "/home",
            component: Home,
            meta: {
                title: '一说春秋',
                dialog: true
            }
        },
        {
            path: "/service",
            component: Service,
            meta: {
                title: '音频图书',
                dialog: true
            }
        },
        {
            path: "/service/:id",
            component: ServiceView,
            meta: {
                title: '内容详情',
                dialog: true,
            }
        },
        { 
            path: '/book/:bid/audio/:id', 
            component: BookAudio,
            meta: {
                title: '音频列表',
                dialog: true,
                footer: 'normal'
            }
        },
    ]
});

import addSupport from './routes/support'
addSupport(router);

import addServices from './routes/services'
addServices(router);

import addUser from './routes/user'
addUser(router);

import addEvent from './routes/event'
addEvent(router);

import addTools from './routes/tools'
addTools(router);

export default router;